import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gap: 20,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  checkBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    alignItems: 'center'
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 16
  },
  hide: {
    opacity: 0
  },
  greenColor: {
    color: theme.palette.secondary.main
  },
  greyColor: {
    color: theme.palette.grey[400]
  }
}))
export default useStyles
